var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPC)?_c('PC'):_c('Mobile')
}
var staticRenderFns = []

export { render, staticRenderFns }